import React from 'react';
import { Progress } from 'tea-component';
import PercentageItemCommon from '@op/components/PercentageItemCommon';
import classnames from 'classnames';
import './index.scss';
import RingRatioBubble from '@op/components/Snippets/RingRatioBubble';
import PercentageItem from '@op/components/Snippets/PercentageItem';
import { reviewsFormat } from '@op/utils/value';

type ProgressProps = {
  className?: string;
  showProgress?: boolean;
  percentage: number;
  value: number;
  emptyValue?: string;
  hideTrend?: boolean;
  totalValue?: number;
  oldTime: Array<string>;
  newTime: Array<string>;
  oldValue: number | string;
  formateValue?: (value: any) => string | number;
  formateDate?: (date: string) => string;
};

const ProgressColumn = (props: ProgressProps) => {
  const {
    className,
    showProgress = false,
    percentage,
    value,
    emptyValue,
    hideTrend,
    totalValue,
    oldTime,
    newTime,
    oldValue,
    formateValue = reviewsFormat,
    formateDate,
  } = props;

  let width = 0;
  if (totalValue && !isNaN(totalValue) && !isNaN(value) && totalValue > 0) {
    width = value / totalValue;
    if (width > 1) width = 1;
  }

  return (
    <div className={classnames('dbo-progress-column', className)}>
      {/* <RingRatioBubble
        oldTime={oldTime}
        newTime={newTime}
        oldValue={oldValue}
        newValue={value}
        showContent={!!value}
        formateValue={formateValue}
        formateDate={formateDate}
      >
        <PercentageItemCommon
          percentage={percentage}
          value={value}
          emptyValue={emptyValue}
          hideTrend={hideTrend}
        />
      </RingRatioBubble> */}

      <PercentageItem className="dbo-numtrends" percentage={percentage}>
        {(percentageElement: any) => (
          <>
            <span className={`dbo-numtrends-num`}>{formateValue(value)}</span>
            <RingRatioBubble
              oldTime={oldTime}
              newTime={newTime}
              oldValue={oldValue}
              newValue={value}
              showContent={!!value}
              formateValue={formateValue}
              formateDate={formateDate}
            >
              {!hideTrend && percentageElement}
            </RingRatioBubble>
          </>
        )}
      </PercentageItem>
      {showProgress && (
        <Progress
          className="progress-bar"
          percent={width * 100}
          strokeWidth={6}
          strokeColor={'#5086f3'}
          theme={'default'}
        />
      )}
    </div>
  );
};

export default ProgressColumn;
